<template>
  <div
    class="i-base-text-cta"
    :style="{ color: props.color, fontSize: props.fontSize }"
    @click="emit('ctaClicked')"
  >
    {{ text }} <img :src="iconArrow" />
  </div>
</template>

<script setup lang="ts">
import { azureRadiance500 } from "@/styles/colors"

// ASSETS
import iconArrow from "@/assets/icons/icon-arrow-right-blue.svg"

// EMITS
const emit = defineEmits(["ctaClicked"])

const props = defineProps({
  color: {
    type: String,
    default: azureRadiance500
  },
  text: {
    type: String,
    required: true
  },
  fontSize: {
    type: String,
    default: "14px"
  }
})
</script>

<style lang="scss" scoped>
.i-base-text-cta {
  @include flex(row, start, center, $gap: 8px);

  font-weight: 600;
  cursor: pointer;

  &:hover {
    filter: brightness(120%);
  }
}
</style>
